module.exports = __webpack_public_path__ + "img/MAZDA.563e229.jpg";